<template>
    <div class="row">
        <div class="col-sm-12">
            <b-nav>
                <b-nav-item :class="[isActiveClass('app.admin.category.news'), 'category']" active :to="{name: 'app.admin.category.news'}">
                    {{$t('components.administration.category.news.title')}}
                </b-nav-item>
            </b-nav>
            <div class="mt-5">
                <router-view/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CategoryOverview",

        computed: {
            isActiveClass() {
                return route => {
                    return this.$route.name === route ? 'active-category' : '';
                }
            }
        }
    }
</script>

<style scoped>
    li {
        padding: 15px;
    }

    .category a {
        border-bottom: 1px solid grey;
    }

    .active-category a {
        color: #b89453 !important;
        font-weight: bold;
        border-bottom: 2px solid #b89453;
    }
</style>
